import { render, staticRenderFns } from "./succession-files-filter.vue?vue&type=template&id=4b4ea23c&scoped=true&"
import script from "./succession-files-filter.vue?vue&type=script&lang=js&"
export * from "./succession-files-filter.vue?vue&type=script&lang=js&"
import style0 from "./succession-files-filter.vue?vue&type=style&index=0&id=4b4ea23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ea23c",
  null
  
)

export default component.exports